/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：VUEルート
 *
 * 作成者：2022/2/23 ノア）黄
 * 最終修正者：2022/2/23 ノア）黄
 *
 */
import { Vue } from 'vue-property-decorator'
import { Route, NavigationGuardNext } from 'vue-router'
import { indexOf } from 'lodash'

import { UserRole } from '@/commons/constants'
import config from '@/config/config'
import { moveService } from '@/commons/services/moveService'
import { localService } from '@/commons/services/localService'
import { dialog } from '@/store/modules'
import { getCookie } from '@/utils/cookieUtils'
import { AccessToken } from '@/commons/constants'

const systemOnlyAccess = [
  config.menu.corporateManagement, // 会社管理
  config.menu.userMaster, // ユーザマスタ
  config.menu.gpsTrackerTerminalConfig, // GPSトラッカー端末判定値設定
  config.menu.alertList // アラートリスト
]

// ITPシステムルーティングパス文字列配列
const routesITPPaths: string[] = Object.values(config.menu).concat(['/'])
// 編集ツール システム ルーティング パス文字列配列
const routesToolPaths: string[] = Object.values(config.toolMenu).concat(['/', config.menu.login])

/**
 * 画面に未保存データがあるかどうかをチェックする
 *
 * @param {Route} to to
 * @param {Route} from from
 * @param {NavigationGuardNext<any>} next next
 * @returns {Promise<any>} チェック結果
 */
// eslint-disable-next-line
export async function changeCheck(to: Route, from: Route, next: NavigationGuardNext<any>): Promise<any> {
  Vue.$log.debug('route > beforeEach > changeCheck, from:', from, ', to:', to)
  // サイドバーを閉じる
  if (dialog.silderBarIsShow) {
    dialog.setSilderBarIsShow()
  }

  if (!moveService.beforePageChange) {
    next()
    return
  }

  moveService.beforePageChange(next)
}

/**
 * 画面にアクセス権限があるかどうかをチェックする
 *
 * @param {Route} to to
 * @param {Route} from from
 * @param {NavigationGuardNext<any>} next next
 * @returns {any} any
 */
// eslint-disable-next-line
export async function roleCheck(to: Route, from: Route, next: NavigationGuardNext<any>): Promise<any> {
  Vue.$log.debug('route > beforeEach > roleCheck, from:', from, ', to:', to)
  if (!localService || !localService.userInfo) {
    next()
    return
  }

  if (localService.userInfo?.role === UserRole.TOOL_ADMIN) {
    if (routesToolPaths.findIndex(item => item === to.path) === -1) {
      next(config.toolMenu.companyHome)
      return
    }

    next()
    return
  }

  if (routesITPPaths.findIndex(item => item === to.path) === -1) {
    next(config.menu.home)
    return
  }

  if (localService.userInfo?.role !== UserRole.SYSTEM) {
    if (indexOf(systemOnlyAccess, to.path) >= 0) {
      next(config.menu.home)
      return
    }
  }

  next()
}

/**
 * cookieがあるかどうかをチェックする
 *
 * @param {Route} to to
 * @param {Route} from from
 * @param {NavigationGuardNext<any>} next next
 * @returns {any} any
 */
// eslint-disable-next-line
export async function cookieCheck(to: Route, from: Route, next: NavigationGuardNext<any>): Promise<any> {
  const token = getCookie(AccessToken)
  if (!token && to.path !== config.menu.login) {
    next(config.menu.login)
    return
  }

  next()
}
